const newsletterModal = {
  displayField: 'adminTitle',
  name: 'Newsletter Modal',
  description: 'This is the fly-out modal that appears on Articles for the Subscribe button',
  fields: [
    {
      id: 'adminTitle',
      name: 'Admin Title',
      type: 'Symbol',
      localized: false,
      required: true,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'introHeadline',
      name: 'Intro Headline',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'introCopy',
      name: 'Intro Copy',
      type: 'RichText',
      localized: true,
      required: false,
      validations: [
        {
          enabledMarks: [ 'bold', 'italic', 'underline', 'superscript', 'subscript' ],
          message: 'Only bold, italic, underline, superscript, and subscript marks are allowed'
        },
        {
          enabledNodeTypes: [
            'heading-3',
            'ordered-list',
            'unordered-list',
            'hyperlink',
            'entry-hyperlink'
          ],
          message: 'Only heading 3, ordered list, unordered list, link to Url, and link to entry nodes are allowed'
        },
        { nodes: {} }
      ],
      disabled: false,
      omitted: false
    },
    {
      id: 'introImage',
      name: 'Intro Image',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkMimetypeGroup: [ 'image' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Asset'
    },
    {
      id: 'successHeadline',
      name: 'SuccessHeadline',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'successCopy',
      name: 'Success Copy',
      type: 'RichText',
      localized: true,
      required: false,
      validations: [
        {
          enabledMarks: [
            'bold',
            'italic',
            'underline',
            'code',
            'subscript',
            'superscript'
          ],
          message: 'Only bold, italic, underline, code, subscript, and superscript marks are allowed'
        },
        {
          enabledNodeTypes: [
            'heading-3',
            'ordered-list',
            'unordered-list',
            'hyperlink'
          ],
          message: 'Only heading 3, ordered list, unordered list, and link to Url nodes are allowed'
        },
        { nodes: {} }
      ],
      disabled: false,
      omitted: false
    },
    {
      id: 'errorHeadline',
      name: 'Error Headline',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'errorCopy',
      name: 'Error Copy',
      type: 'RichText',
      localized: true,
      required: false,
      validations: [
        {
          enabledMarks: [
            'bold',
            'italic',
            'underline',
            'code',
            'superscript',
            'subscript'
          ],
          message: 'Only bold, italic, underline, code, superscript, and subscript marks are allowed'
        },
        {
          enabledNodeTypes: [
            'heading-3',
            'ordered-list',
            'unordered-list',
            'hyperlink'
          ],
          message: 'Only heading 3, ordered list, unordered list, and link to Url nodes are allowed'
        },
        { nodes: {} }
      ],
      disabled: false,
      omitted: false
    },
    {
      id: 'invalidEmailMessages',
      name: 'Invalid Email Messages',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'missingEmailMessage',
      name: 'Missing Email Message',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    }
  ],
  sys: {
    id: 'newsletterModal',
    version: 6,
    updatedAt: '2023-12-18T17:03:44.586Z'
  }
};
export default newsletterModal;